export const TITLE = 'Authentik';
export const COLOR_PRIMARY = '#FD4B2D';
